import { getLocale } from "./services/utils";
/* eslint-disable import/default */

import React, { Suspense } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import ThemeDefault from "./theme-default";
import { createRoot } from "react-dom/client";
import { StripeProvider } from "react-stripe-elements";
import "core-js/stable";
import "regenerator-runtime/runtime";
require("./favicon.ico");
require("react-activity/lib/Dots/Dots.css");
require("react-dates/lib/css/_datepicker.css");
require("./img/logo.png");
require("./img/tf_pp.png");
require("./img/testdrive.png");
require("./img/download_ios_store.png");
require("./img/download_play_store.png");
require("./img/signup.jpg");
require("./img/c1.png");
require("./img/c2.png");
require("./img/c3.png");
require("./img/c4.png");
require("./img/c5.png");
require("./img/c6.png");
require("./img/c7.png");
require("./img/c8.png");
require("./img/logo2.png");
require("./img/logo3.png");
require("./img/logo4.png");
require("./img/paypalLogo.png");
require("./img/emptyState.png");
require("./img/comment.png");
require("./img/icon-add.png");
require("./img/icon-close.png");
require("./img/icon-edit.png");
require("./img/icon-skip-message.png");
require("./img/icon-warning.png");
require("./img/weight-small.png");
require("./img/goal.png");
require("./img/lock.png");
require("./img/goalUnlocked.png");
require("./img/log1stWorkout.png");
require("./img/log25Workouts.png");
require("./img/log75Workouts.png");
require("./img/log100Workouts.png");
require("./img/perfectHalfYear.png");
require("./img/perfectMonth.png");
require("./img/perfectQuarter.png");
require("./img/perfectWeek.png");
require("./img/perfectYear.png");
require("./img/personalRecord.png");
require("./img/stripeConnect.png");
require("./img/pattern1.png");
require("./img/iconHistory.png");
require("./img/play-video-white.png");
require("./img/play-video-icon.png");
require("./img/signin-with-google.png");
require("./img/emptyWorkout.png");
require("./img/onboarding-autoresponder.png");
require("./img/onboarding-client.png");
require("./img/onboarding-habits.png");
require("./img/onboarding-links.png");
require("./img/onboarding-packages.png");
require("./img/onboarding-triggered-messaging.png");
require("./img/onboarding-workout-templates.png");
require("./img/onboarding-groups.png");
require("./img/onboarding-news-feed.png");
require("./img/no-nutrition.png");
require("./img/no-record-found.png");
require("./img/resources.png");
require("./img/mobile-links.png");
require("./img/hand-icon.png");
require("./img/search-icon.png");
require("./img/left-arrow.png");
require("./img/right-arrow.png");
require("./img/anytime.png");
require("./img/burnboot.png");
require("./img/credit-card-info.svg");
require("./img/gold.png");
require("./img/lifetime.png");
require("./img/no-contracts.svg");
require("./img/no-fuss.svg");
require("./img/signup-bg.png");
require("./img/signup-img.png");
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "font-awesome/css/font-awesome.css";
import "flexboxgrid/css/flexboxgrid.css";
import "react-circular-progressbar/dist/styles.css";
require("./styles.css");
require("./draft.css");
import { Provider } from "react-redux";
import store, { persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import LoadingBar from "react-redux-loading-bar";
import ReduxToastr from "react-redux-toastr";
import { primary } from "./constants/colors";
import * as Sentry from "@sentry/browser";
import "react-select/dist/react-select.css";
import { loadReCaptcha } from "react-recaptcha-v3";
import { RouterProvider } from "react-router";
import "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import moment from "moment";
import { router } from "./router";

// Redirect to /web if the app is loaded outside the basename
if (!window.location.pathname.startsWith("/web")) {
  window.location.replace("/web" + window.location.pathname + window.location.search + window.location.hash);
}

const STRIPE_API_KEY = process.env.STRIPE_API_KEY;

Sentry.init({
  dsn: "https://b50e116166ad4840b254915eaad97c2c@sentry.io/199892",
  release: process.env.SENTRY_RELEASE_VERSION,
});

let lng = getLocale();
moment.locale(lng);
loadReCaptcha(process.env.RECAPTCHA_KEY);

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <StripeProvider apiKey={STRIPE_API_KEY}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MuiThemeProvider theme={ThemeDefault}>
          <div>
            <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
              <div>
                <LoadingBar
                  style={{
                    backgroundColor: primary,
                    zIndex: "12000",
                    position: "fixed",
                    top: 0,
                  }}
                  showFastActions
                />
                <Suspense fallback={null}>
                  <RouterProvider router={router} />
                </Suspense>
                <ReduxToastr
                  timeOut={6000}
                  newestOnTop={true}
                  preventDuplicates={false}
                  position="top-right"
                  transitionIn="fadeIn"
                  transitionOut="fadeOut"
                  progressBar={false}
                  showCloseButton={true}
                />
              </div>
            </GoogleOAuthProvider>
          </div>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  </StripeProvider>,
);
